import {BufferSchema, uint8} from '@geckos.io/typed-array-buffer-schema';
import {MultiplayerModel} from './schemaModel.js';
import {DEFAULT_BLOOD_COLOR, normalizeBloodColor} from '../../static/mod/bloodColors.js';

// Optional reliable metadata sent with the skin, leaving existing pose and
// introduction packets compatible. Older peers simply keep the red default.
export const bloodColorModel = new MultiplayerModel(BufferSchema.schema('bloodColor', {r: uint8, g: uint8, b: uint8}));
export function encodeBloodColor(color) {
    const value = parseInt((normalizeBloodColor(color) || DEFAULT_BLOOD_COLOR).slice(1), 16);
    return bloodColorModel.toBuffer({r: value >> 16, g: value >> 8 & 255, b: value & 255});
}
export function decodeBloodColor(buffer) {
    const {r, g, b} = bloodColorModel.fromBuffer(buffer);
    return '#' + [r, g, b].map(value => value.toString(16).padStart(2, '0')).join('');
}
